import { FC } from 'react';

import useRateItemMutation from 'api/mutations/useRateItemMutation';
import FormikRating from 'components/form/FormikRating';
import FormikTextArea from 'components/form/FormikTextArea';
import CommonModal from 'components/modals/CommonModal';
import SuccessModal from 'components/modals/SuccessModal';
import Button from 'components/primitives/Button';
import { Form, Formik } from 'formik';
import ModalReference from 'helperClasses/modalReference';
import { ReviewPayload } from 'types/reviews';
import { RateItemProps } from './RateItem.props';
import { initialData, validationSchema } from './RateItem.utils';

const RateItemView: FC<RateItemProps> = ({
  child,
  onSuccess,
  rentId,
  renterId,
  itemId,
}) => {
  const modalRef = new ModalReference();
  const successModalRef = new ModalReference();

  const showRatingDialog = () => {
    modalRef.open();
  };

  const { mutate: rate, isPending } = useRateItemMutation((data: any) => {
    onSuccess && onSuccess();
    handleModalsOnSuccess();
  });

  const onSubmit = (data: typeof initialData) => {
    //mutation will go here

    const renterCaracteristics: any = [];

    const payload: ReviewPayload = {
      reviewerId: renterId,
      itemId: itemId,
      rentId: rentId,
      description: data.description,
      rate: data.value,
      renterCaracteristics: renterCaracteristics,
    };

    rate(payload);
  };

  const handleModalsOnSuccess = () => {
    modalRef.close();
  };

  return (
    <div>
      <div className="cursor-pointer" onClick={showRatingDialog}>
        {child}
      </div>
      <SuccessModal
        title="Feedback Sent!"
        description={`We're thrilled to have you on board. Rapid Rentals is all about making renting and lending easier and more enjoyable. Let's take you through the options you have on our platform.`}
        ref={successModalRef.getReference()}
      />
      <CommonModal ref={modalRef.getReference()}>
        <div className="px-8 lg:px-60 py-10 w-full flex flex-col justify-center items-center space-y-8">
          <h1 className="text-3xl">Rate the item</h1>
          <Formik
            onSubmit={(values, { resetForm }) => {
              onSubmit(values);
              resetForm();
            }}
            initialValues={initialData}
            validationSchema={validationSchema}>
            {({ isValid }) => {
              return (
                <Form className="space-y-8 flex flex-col justify-center items-center">
                  <FormikRating name="value" />
                  <FormikTextArea
                    name="description"
                    placeholder="Here you can explain better"
                  />
                  <Button
                    isDisabled={!isValid}
                    isLoading={isPending}
                    variant="solid"
                    colorScheme="primary">
                    Send feedback
                  </Button>
                </Form>
              );
            }}
          </Formik>
        </div>
      </CommonModal>
    </div>
  );
};

export default RateItemView;
